module.exports = __webpack_public_path__ + "likeqiang.5940ff8e.png";